import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Text, Spinner, Paragraph, Box } from '@zillow/constellation';
import { fetchRatesArticle } from './MortgageRatesSummary.utils.js';
import { setServerUrl, PAGE_FLAVOR_LOAN_TYPE_MAP, LOAN_TYPES } from '../../utils/mortgagehelpers/mortgage-helpers.js';
import MortgagePageClassification from '../../utils/mortgagehelpers/MortgagePageClassification.js';
import { RatesArticle } from './RateArticle.js';
import LegalDisclosuresModal from '../LegalDisclosuresModal/LegalDisclosuresModal.js';

var MortgageRatesSummary = function MortgageRatesSummary(_ref) {
  var pathname = _ref.pathname,
    blockData = _ref.blockData;
  var classification = new MortgagePageClassification(pathname ? pathname : '/mortgage-rates/');
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    article = _useState2[0],
    setArticle = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  useEffect(function () {
    setServerUrl();
  }, []);
  useEffect(function () {
    var _PAGE_FLAVOR_LOAN_TYP;
    fetchRatesArticle({
      refinance: classification.refinance,
      stateAbbreviation: classification.stateAbbreviation,
      loanType: (_PAGE_FLAVOR_LOAN_TYP = PAGE_FLAVOR_LOAN_TYPE_MAP[classification.flavor]) !== null && _PAGE_FLAVOR_LOAN_TYP !== void 0 ? _PAGE_FLAVOR_LOAN_TYP : LOAN_TYPES.Conventional,
      program: 'Fixed30Year'
    }).then(function (response) {
      if (response.hasApiError) {
        setError(true);
        setLoading(false);
      } else {
        setArticle(response);
        setLoading(false);
      }
    });
  }, []);
  if (loading) {
    return /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Spinner, null), " Loading...");
  } else if (error) {
    return /*#__PURE__*/React.createElement(Paragraph, null, "An error occurred, please try again later.");
  } else {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RatesArticle, {
      article: article
    }), /*#__PURE__*/React.createElement(Box, {
      sx: {
        marginTop: '$spacing.sm'
      }
    }, /*#__PURE__*/React.createElement(LegalDisclosuresModal, {
      classification: classification,
      rates: (blockData === null || blockData === void 0 ? void 0 : blockData.rates) || {}
    })));
  }
};
MortgageRatesSummary.propTypes = process.env.NODE_ENV !== "production" ? {
  pathname: PropTypes.string,
  blockData: PropTypes.object
} : {};
var MortgageRatesSummary$1 = MortgageRatesSummary;

export { MortgageRatesSummary$1 as default };
